import { Injectable } from '@angular/core';
import { SafeArea } from '@capacitor-community/safe-area';

export type SafeAreaStyle = 'light' | 'dark';

@Injectable({ providedIn: 'root' })
export class SafeAreaProvider {
    private navbarStyle: SafeAreaStyle = 'dark';
    private statusbarColor: string = '#005EFFFF';
    private navbarColor: string = '#000000FF';
    private statusbarStyle: SafeAreaStyle = 'light';

    enable() {
        this.applySafeArea();
    }

    setNavbarStyle(style: SafeAreaStyle) {
        this.navbarStyle = style;
        this.applySafeArea();
    }

    setNavbarColor(color: string) {
        this.navbarColor = color;
        this.applySafeArea();
    }

    setStatusbarColor(style: SafeAreaStyle) {
        this.statusbarStyle = style;
        this.applySafeArea();
    }

    private applySafeArea() {
        SafeArea.enable({
            config: {
                customColorsForSystemBars: true,
                navigationBarColor: this.navbarColor,
                statusBarColor: this.statusbarColor,
                navigationBarContent: this.navbarStyle,
                statusBarContent: this.statusbarStyle,
                offset: 0,
            }
        });
    }
}